import { router } from '@inertiajs/react';
import { Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import type { RequestItem } from '@/types';

interface HasModel<T> { model: T }
const hasModel = <T,>(p: unknown): p is HasModel<T> =>
  typeof p === 'object' && p !== null && 'model' in (p as Record<string, unknown>);

// RevoGrid passes 'model' containing the complete row data object
export const RequestItemActionsCell = (props: unknown) => {
  let item: RequestItem;
  if (hasModel<RequestItem>(props)) {
    item = props.model;
  } else {
    item = props as RequestItem;
  }

  const handleDelete = () => {
    if (confirm('¿Está seguro de que desea eliminar este ítem?')) {
      router.delete(`/request_items/${item.id}`, { preserveScroll: true });
    }
  };

  return (
    <div className="flex justify-center items-center h-full">
      <Button variant="ghost" size="icon" onClick={handleDelete} className="h-6 w-6 text-red-600">
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
};